import { FC } from 'react';
import { DataCellProps } from '../types';
import { falsyCheckDate } from 'utils';

export const TeamMemberLastActiveCell: FC<DataCellProps> = ({ _customRowProps, member }) => {
  return <div>{falsyCheckDate(member.last_active)}</div>;
};
